export enum TAB_VIEW {
  CATEGORIES_PURPOSES = 'categories_purposes',
  SERVICES_VENDORS = 'services_vendors',
}
